import { useState } from 'react';

import { Input, Label, Modal, dialogService } from '@thefarmersfront/kitchen';

import {
  canConfirmShippingLabelQuantity,
  canCreateShippingLabelQuantity,
  isShippingLabelQuantityExceeded,
  sanitizeShippingLabelQuantity,
} from '~/utils/delivery-agency/shippingLabelQuantity';

import { MAX_SHIPPING_LABEL_QUANTITY } from '~/constants';

import styles from './DeliveryAgencyTrackingCreateShippingLabelQuantityModal.module.scss';

const QUANTITY_EXCEEDED_MESSAGE = `1회 최대 ${MAX_SHIPPING_LABEL_QUANTITY}개까지 생성가능합니다.`;

const DeliveryAgencyTrackingCreateShippingLabelQuantityModal = ({
  open,
  isCreating,
  onConfirm,
  onClose,
}: {
  open: boolean;
  isCreating: boolean;
  onConfirm: (quantity: number) => void;
  onClose: () => void;
}) => {
  const [quantity, setQuantity] = useState('');

  const handleConfirm = () => {
    if (isCreating || !canCreateShippingLabelQuantity(quantity)) return;

    dialogService.addDialog({
      type: 'confirm',
      children: `추가 운송장을 ${Number(quantity)}개 생성하시겠습니까?`,
      onConfirm: () => onConfirm(Number(quantity)),
    });
  };

  const handleCancel = () => {
    if (canConfirmShippingLabelQuantity(quantity)) {
      dialogService.addDialog({
        type: 'confirm',
        children: '아직 추가 운송장을 생성하지 않았습니다.\n팝업을 종료 하시겠습니까?',
        onConfirm: onClose,
      });
      return;
    }

    onClose();
  };

  return (
    <Modal
      title={
        <div className={styles['title']}>
          <span className={styles['title-text']}>운송장 생성</span>
          <span className={styles['title-guide']}>최대 {MAX_SHIPPING_LABEL_QUANTITY}개</span>
        </div>
      }
      size="small"
      depth={2}
      cancelText="취소"
      confirmText="확인"
      disabled={isCreating || !canConfirmShippingLabelQuantity(quantity)}
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <div className={styles['body']}>
        <Label className={styles['label']} title="운송장 수량" required />
        <Input
          type="text"
          size="small"
          placeholder="숫자만 입력"
          unit="개"
          maxLength={3}
          maxWidth="240px"
          status={isShippingLabelQuantityExceeded(quantity) ? 'error' : 'default'}
          validationMessage={QUANTITY_EXCEEDED_MESSAGE}
          value={quantity}
          onChange={(e) => setQuantity(sanitizeShippingLabelQuantity(e.target.value))}
        />
      </div>
    </Modal>
  );
};

export default DeliveryAgencyTrackingCreateShippingLabelQuantityModal;
